module.exports = __webpack_public_path__ + "static/media/background-image@3x.fd15e7ec.jpg";